import {join} from 'lodash';
import moment from 'moment';
import axios from 'axios'
import tz from 'moment-timezone'; //DO NOT REMOVE

export const updateQuerySting = (key, value, userSearch = null) => {
    let search = window.location.search;

    if (search === '' && !userSearch) return `?${key}=${value}`;
    if (userSearch) search = userSearch;
    if (!search.includes(`${key}=`))  return `${search}&${key}=${value}`;

    let queries = search.split('&');
    
    queries = queries.map(term => {
        if (term.includes(key)) {
            let newTerms = term.split('=');
            
            return newTerms[0].concat('=' + value);
        }

        return term;
    });

    return join(queries, '&');
}

export const newLocation = (path, query) => {
    let pathname = path;

    if (!path) pathname = window.location.pathname;
    
    window.location = window.location.origin + pathname + query;
}

export const getQueryValue = (key, _default) => {
    const search = window.location.search;

    if (!search.includes(`${key}=`) || search === '') return _default;

    const queries = search.split('&');
    let value = _default;

    queries.forEach(term => {
        if (term.includes(`${key}=`)) value = term.split('=')[1];
    });

    return value;
}

export const ruleIsRequired = (fieldSettings, allRules, key, values)=>{
    if(fieldSettings.required) return true;
    
    let logicRequired = false;
    
    for (let rule in allRules) {
        if (key === rule) continue;
        
        const value = values[rule];
        
        if (allRules[rule].options && allRules[rule].options[value] && allRules[rule].options[value].requires) {
            logicRequired = allRules[rule].options[value].requires.includes(key);
        }
    }
    
    return logicRequired;
}

export const ruleShouldShow = (fieldSettings, allRules, key, values)=>{
    let logicShows = null;
    
    for (let rule in allRules) {
        if (key === rule) continue;
        
        const value = values[rule];
        
        if (allRules[rule].options && allRules[rule].options[value] && allRules[rule].options[value].shows) {
            logicShows = allRules[rule].options[value].shows.includes(key);
        }
    }
    
    if(logicShows !== null ) return logicShows;
    
    return true;
}

export const checkRequiredAreNotEmpty = (settings_object, values) => {
    let invalids = [];
    
    if (settings_object) {
        Object.keys(settings_object).filter(key => key !== 'json_info').forEach(setting =>{
            const isRequired = ruleIsRequired(settings_object[setting], settings_object, setting, values);
            const valueNotSet = !values[setting];
            
            if (isRequired && valueNotSet) invalids.push(setting);
        });
    }
    
    return invalids;
}

export const isValidJSON = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    
    return true;
}

export const maybeParseValue = value => {
    return isValidJSON(value) ? JSON.parse(value) : value;
}

export const seconds = (seconds) => {
    return seconds * 1000;
}

export const minutes = (minutes) => {
    return minutes * 1000 * 60;
}

export const cacheExpired = (expireTime) => {
    return expireTime ? Date.now() > expireTime : true;
}

export const dataFromCache = (cache, cacheKey) => {
    return canUseCache(cache, cacheKey) ? cache.items[cacheKey] : false;
}

export const canUseCache = (cache, cacheKey) => {
    return cache.items[cacheKey] && !cacheExpired(cache.expires[cacheKey]);
}

export const userHasRole = (user, role) => {
    role = Array.isArray(role) ? role : [role];
    
    return !!user.roles.filter(r => role.includes(r.slug)).length;
}

export const objToQueryString = (obj) => {
    return Object.keys(obj).map(key => key + '=' + obj[key]).join('&')
}

export const setCustomTooltips = () => {
    window.setCustomTooltips();
}

export const maybeFixDate = date => {
    return typeof date === 'number' ? parseFloat(date) * 1000 : date;
}

export const simpleDate = (date, correctUNIX = false) => {
    if (correctUNIX) date = maybeFixDate(date);
    
    return moment(date).format('M/D/YY');
}

export const prettyDate = (date, fromNow = false, dateFirst = false, correctUNIX = false) => {
    if (correctUNIX) date = maybeFixDate(date);
    
    const localTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const centralTime = moment.tz(date, 'America/Chicago');
    
    if (fromNow) return `about ${centralTime.tz(localTZ).fromNow()}`;
    
    const format = dateFirst ? 'MMM Do YYYY \a\t h:mma z ddd' : 'h:mma z ddd, MMM Do YYYY';
    
    return `${centralTime.tz(localTZ).format(format)}`;
}

export const getTimeZone = (tz, escaped = false) => {
    if (tz.endsWith('New_York')) {
        return escaped ? '\\E\T' : 'ET';
    } else if (tz.endsWith('Chicago')) {
        return escaped ? '\\C\T' : 'CT';
    } else if (tz.endsWith('Denver')) {
        return escaped ? '\\M\T' : 'MT';
    } else if (tz.endsWith('Los_Angeles')) {
        return escaped ? '\\P\T' : 'PT';
    }
    
    return '';
}

export const prettyPhone = phone => {
    if (phone.length === 10) {
        return phone.replace(/(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');
    } else if (phone.length > 10) {
        return phone.replace('+', '').replace(/^(1|)?(\d{3})(\d{3})(\d{4})$/, '($2) $3-$4');
    }
    
    return phone;
}

export const checkForInternetConnection = async ()=>{
    try{
        await axios.get('/test-internet-connection')
        return true
    }catch(err){return false}
}

export const onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index;
}

export const leadColumns = (cols, additionalOptions = []) => {
    const scnParts = ['client', 'campaign', 'notes', 'pmc', 'p_code', 'agency', 'client_id', 'industry'].map(part => `scn.${part}`);
    
    return cols
        .concat([...scnParts, ...additionalOptions])
        .filter(col => col !== 'product')
        .filter(onlyUnique)
        .sort();
}